import React from 'react';
import { Provider, observer } from 'mobx-react';
import { action } from 'mobx';
import { BrowserRouter, Switch, Route, Redirect, Link } from 'react-router-dom';
import { DragDropContext } from 'react-beautiful-dnd';
import { Row, Col, Button, Glyphicon } from 'react-bootstrap';
import { AxiosHelpers } from '../../libs/axios_csrf';

////////////   Localization ///////////////////////////
import { IntlProvider } from 'react-intl';
import boardLocales from '../../locales/board.json';
import bmcLocales from '../../locales/bmc.json';
///////////////////////////////////////////////////////

import RootStore from './stores/RootStore';
import { ROUTE_PATH } from './constants';
import BmcLoading from './BmcLoading';
import StepByStepMode from './StepByStepMode';
import BsAlert from '../common_components/BsAlert';

import LocaleStore from '../common_components/localization/LocaleStore';
import Show from './Show';
import { BMC_BLOCKS } from '../common_components/bmc/bmc_constants';
import MvpStore from '../igmvp_components/stores/Mvps';

import { TOOLTIPPROPS_CONSTRUCTOR } from './constantsTooltips';
import MainTooltips from '../common_components/tooltips/MainTooltips';
import TooltipStore from '../common_components/tooltips/TooltipStore';
import { RenderInstructional } from '../instructional_feed_components/RenderInstructional';

//////// Use Mobx-react-devtools only in development enviroment ///////////
let DevTools;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  DevTools = require('mobx-react-devtools').default;
} else {
  DevTools = () => null;
}
////////////////////////////////////////////////////////////////////////////

@observer
export default class Main extends React.Component {
  static defaultProps = {
    showStages: true,
  };

  constructor(props) {
    super(props);

    const localeStore = new LocaleStore(props.userLocale, [
      bmcLocales,
      boardLocales,
    ]);

    this.rootStore = new RootStore(props, localeStore);
    this.authorizationStore = this.rootStore.authorizationStore;
    this.onDragEnd = this.onDragEnd.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    AxiosHelpers.avoidWindowLeave();
    props.initRootStore && props.initRootStore(this.rootStore);

    if (props.oneBlockMode) {
      this.rootStore.oneBlockMode = props.oneBlockMode;
    }

    const params = new URLSearchParams(window.location.search);
    const modal = params.get('modal');
    this.state = { modal: modal };
    // console.log(props);
    // console.log(props.tooltipProps);

    this.tooltipStore = new TooltipStore(
      this.rootStore,
      TOOLTIPPROPS_CONSTRUCTOR(props.tooltipProps),
    );
    this.rootStore.tooltipStore = this.tooltipStore;
  }

  render() {
    /* The first time a user pass for BMC, 
        goes to STEP BY STEP MODE, otherwise, it goes to SHOW mode*/

    return (
      <DragDropContext
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
      >
        <IntlProvider
          locale={this.rootStore.localeStore.locale}
          messages={this.rootStore.localeStore.messages}
        >
          <Provider
            rootStore={this.rootStore}
            suggestStore={this.rootStore.suggestStore}
          >
            <div className="bmc">
              <MainTooltips
                customJoyrideProps={{
                  scrollToFirstStep: false,
                  spotlightClicks: true,
                }}
              />
              <div className="back-canvas">
                <BsAlert rootStore={this.rootStore} />

                {this.rootStore.loading ? (
                  <BmcLoading />
                ) : (
                  <div>
                    <RenderInstructional
                      section={this.state.modal}
                      show={this.state.modal == 'business'}
                    />
                    <Switch>
                      <Route
                        path={`${ROUTE_PATH}/step_mode/`}
                        component={this.authorizationStore.authUpdate(
                          StepByStepMode,
                        )}
                      />

                      <Route
                        path={ROUTE_PATH}
                        component={this.authorizationStore.authShow(
                          Show,
                          false,
                          {
                            modal: this.state.modal,
                          },
                        )}
                      />

                      {/*<Route exact path={"/:locale?/bmc_boards/:id?/interactive"}
                                                   component={AUTH_EDIT(Interactive, false, 
                                                    {rootStore: this.rootStore})}        
                                            />*/}

                      {/*<Route render={() => <Redirect to={'/home/'} />} />*/}
                    </Switch>
                  </div>
                )}
              </div>
              <DevTools />
            </div>
          </Provider>
        </IntlProvider>
      </DragDropContext>
    );
  }

  @action
  onDragStart(result) {
    //console.log("onDragStart");
  }

  @action
  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination || !this.authorizationStore.canEdit) {
      return;
    }

    if (result.type === 'BLOCK_BODY') {
      const sourceBlock = this.rootStore.blocks[
        Number(result.source.droppableId)
      ];
      const destinationBlock = this.rootStore.blocks[
        Number(result.destination.droppableId)
      ];

      const blockChanged = sourceBlock.id !== destinationBlock.id;

      const draggableCard = sourceBlock.cards.find(
        c => c.id === result.draggableId,
      );
      sourceBlock.cards.remove(draggableCard);

      // const [removed] = sourceBlock.cards.splice(result.source.index, 1);
      destinationBlock.cards.splice(result.destination.index, 0, draggableCard);
      // update card's block store
      draggableCard.store = destinationBlock;

      destinationBlock.updateCardPosition(
        draggableCard,
        result.destination.index,
        blockChanged,
      );
    }
  }

  @action
  componentDidMount() {
    this.rootStore.fetchData();
  }

  @action componentDidUpdate(prevProps) {
    if (prevProps.showStages !== this.props.showStages) {
      this.rootStore.setShowStages(this.props.showStages);
    }
  }

  @action
  componentWillMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.rootStore.pathname = window.location.pathname;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    //window.history.pushState({}, "", this.rootStore.pathname);
  }

  @action
  updateWindowDimensions() {
    this.rootStore.windowsDimensions = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.bmcId !== this.rootStore.bmcId) {
      const localeStore = new LocaleStore(nextProps.userLocale, [
        bmcLocales,
        boardLocales,
      ]);
      this.rootStore = new RootStore(nextProps, localeStore);
      this.rootStore.tooltipStore = this.tooltipStore;
      this.tooltipStore.rootStore = this.rootStore;
      this.authorizationStore = this.rootStore.authorizationStore;
      this.rootStore.fetchData();

      AxiosHelpers.avoidWindowLeave();
      nextProps.initRootStore && nextProps.initRootStore(this.rootStore);

      this.updateWindowDimensions();
      window.removeEventListener('resize', this.updateWindowDimensions);
      window.addEventListener('resize', this.updateWindowDimensions);

      this.rootStore.pathname = window.location.pathname;
      if (nextProps.oneBlockMode) {
        this.rootStore.oneBlockMode = nextProps.oneBlockMode;
      } else {
        this.rootStore.oneBlockMode = {
          active: false,
          name: BMC_BLOCKS.CUSTOMER_SEGMENTS,
        };
      }
    }
  }
}
